<template>

  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店营业收支</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button size="mini"  @click="showExpendDialog">添加支出</el-button>
    <el-button size="mini"  @click="showSrDialog">添加收入</el-button>
    <el-date-picker
      v-model="baseRequest.selectDate"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      size="mini"
      @change="queryOrgExpendList"
    >
    </el-date-picker>
    <el-select v-model="selectOrgId" size="mini" style="width: 200px" value clearable filterable
               placeholder="请选择机构" class="select" @change="getSelectShop">
      <el-option
        v-for="org in orgList"
        :key="org.id"
        :label="org.orgName"
        :value="org.id">
      </el-option>
    </el-select>
    <el-select v-model="baseRequest.expendTypeEnName" clearable value filterable placeholder="请选择检索类型"
               size="mini">
      <el-option
        v-for="expendType in selectExpendTypes"
        :key="expendType.id"
        :label="expendType.expendCnName"
        :value="expendType.expendEnName">
      </el-option>
    </el-select>
    <el-button size="mini"  @click="queryOrgExpendList">查询</el-button>
    <el-table height="550px" :data="orgExpendList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}"
              :cell-style="orderStateColor">
      <el-table-column
        label="操作"
        fixed="fixed"
        align="center"
        width="100">
        <template slot-scope="scope" >
          <div style="display: flex;justify-content: space-evenly">
            <el-link icon="el-icon-edit" size="mini" :disabled="!authorities.includes('finance.edit.sz')"
                     type="primary"  @click="showUpdateExpendDialog(scope.row)"
            ></el-link>
            <el-link type="primary" icon="el-icon-delete" @click="deleteOrgExpend(scope.row)"></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="expendDate"
        width="120"
        label="日期">
      </el-table-column>
      <el-table-column
        align="center"
        prop="szType"
        label="收支分类"
        :formatter="szFormatter"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="expendTypeCnName"
        label="收支类型"
        :formatter="nameFormatter"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="money"
        label="收支费用">
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="所属机构">
      </el-table-column>
      <el-table-column
        align="center"
        prop="comment"
        label="备注说明">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createName"
        label="创建人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyName"
        label="最后修改人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="modifyTime"
        label="最后修改时间">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 30, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="currentTotal">
    </el-pagination>

    <!-- 添加支出 -->
    <el-dialog
      title="创建支出"
      :visible.sync="expendDialogVisible"
      width="60%"
      @close="closeExpendDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly; width: 100%;align-items: center">
          <label style="color: #FA5858">*</label>
          <span style="width: 30%">选择日期:</span>
          <el-date-picker
            v-model="expend.expendDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            size="mini"
            style="width: 60%"
            :disabled="true"
          >
          </el-date-picker>
          <label style="color: #FA5858">*</label>
          <span style="width: 30%">支出类型:</span>
          <el-select v-model="expend.expendTypeEnName" clearable value filterable placeholder="请选择支出类型"
                     style="width: 60%" size="mini" @change="getExpendType">
            <el-option
              v-for="expendType in expendTypes"
              :key="expendType.id"
              :label="expendType.expendCnName"
              :value="expendType.expendEnName">
            </el-option>
          </el-select>

          <label style="color: #FA5858">*</label>
          <span style="width: 30%">支出金额:</span>
          <el-input v-model="expend.money" style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <div style="text-align: right">
          <el-button v-if="orgLevel < 3" size="mini" plain @click="showShopDialog">选择门店</el-button>
        </div>
        <el-table v-if="orgLevel < 3" :data="selectShops" fit border stripe="stripe" width="100%"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="100">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteShopShowList(scope.$index, selectShops)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orgName"
            label="门店">
          </el-table-column>
      </el-table>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <span>备注说明：</span>
        <el-input v-model="expend.comment" style="width: 100%" size="mini" type="textarea"></el-input>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeExpendDialog">取 消</el-button>
        <el-button size="mini" @click="createExpend">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加支出 -->
    <el-dialog
      title="更新支出"
      :visible.sync="updateExpendDialogVisible"
      width="60%"
      @close="closeUpdateExpendDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly; width: 100%;align-items: center">
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">选择日期:</span>
            <el-date-picker
              v-model="updateExpend.expendDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 70%"
            >
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">支出类型:</span>
            <el-input v-model="updateExpend.expendTypeCnName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">支出金额:</span>
            <el-input v-model="updateExpend.money" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
          <div style="display: flex;justify-content: flex-start;align-items: center">
            <span style="width: 60px">所属门店:</span>
            <el-input v-model="updateExpend.shopName" disabled style="width: 60%" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <span>备注说明：</span>
        <el-input v-model="updateExpend.comment" style="width: 100%" size="mini" type="textarea"></el-input>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeUpdateExpendDialog">取 消</el-button>
        <el-button size="mini" @click="updateShopExpend">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加收入 -->
    <el-dialog
      title="创建收入"
      :visible.sync="srDialogVisible"
      width="60%"
      @close="closeSrDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly;justify-items: center">
          <div>
            <label style="color: #FA5858">*</label>
            <span>选择日期：</span>
            <el-date-picker
              v-model="expend.expendDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini"
              style="width: 60%"
              :disabled="true"
            >
            </el-date-picker>
          </div>
          <div >
            <label style="color: #FA5858">*</label>
            <span>收入金额：</span>
            <el-input style="width: 50%" v-model="expend.money" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div style="text-align: right" v-if="orgLevel == 2">
          <el-button size="mini" style="margin-left: 10px"  plain @click="showShopDialog">选择门店</el-button>
        </div>
        <el-table v-if="orgLevel < 3" style="margin-top: 5px" :data="selectShops" fit border stripe="stripe" width="100%"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="60">
            <template slot-scope="scope">
              <el-link type="danger" icon="el-icon-delete"
                       @click="deleteShopShowList(scope.$index, selectShops)"></el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="orgName"
            label="门店">
          </el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <span>备注说明：</span>
        <el-input v-model="expend.comment" style="width: 100%" size="mini" type="textarea"></el-input>
      </el-card>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeSrDialog">取 消</el-button>
        <el-button size="mini" @click="createSr">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 选择门店 -->
    <el-drawer
      title="门店列表"
      size="40%"
      :visible.sync="shopDialogVisible"
      :before-close="closeShopDialog"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
<!--      <el-input size="mini" placeholder="输入门店名称进行检索" v-model="baseRequest.queryText" @change="loadShop"></el-input>-->
      <el-table :data="shops" fit border stripe="stripe" width="100%"  size="mini"
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                height="550px"
                @selection-change="selectShopMethod">
        <el-table-column
          align="center"
          type="selection"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orgName"
          label="门店名称">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="currentPage1"
        :page-sizes="[15, 30, 50, 100]"
        :page-size="pageSize1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currentTotal1">
      </el-pagination>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      userName:'',
      authorities:'',
      orgId:'',
      orgLevel:'',
      orgExpendList:[],
      expendEnName:'',
      expendTypes:[],
      selectExpendTypes:[],
      orgList:[],
      shops:[],
      expendDialogVisible:false,
      updateExpendDialogVisible:false,
      expend:{
        expendDate:'',
        money:'',
        orgId:'',
        creator:'',
        expendTypeEnName:'',
        comment:'',
        szType:'',
        orgIds:[],
        createName:''
      },
      updateExpend:'',
      baseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        queryText:'',
        orgIds:[],
        expendTypeEnName:''
      },
      currentPage: 1,
      pageSize: 30,
      currentTotal: 0,
      srDialogVisible:false,
      selectOrgId:'',
      shopDialogVisible:false,
      selectShops:[],
      currentPage1: 1,
      pageSize1: 30,
      currentTotal1: 0,
    }
  },
  methods:{
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    showExpendDialog(){
      this.expend.expendTypeEnName = '';
      this.expend.money = '';
      this.expend.expendDate = '';
      this.expend.comment = '';
      this.selectShops = [];
      this.expendDialogVisible = true;
    },
    closeExpendDialog(){
      this.expendDialogVisible = false;
    },
    async createExpend(){
      if (this.expend.expendTypeEnName === ''){
        return this.$message.warning("请选择支出类型！")
      }
      if (this.expend.money === ''){
        return this.$message.warning("请填写金额！")
      }
      this.expend.creator = this.userId;
      this.expend.orgId  = this.orgId;
      this.expend.expendTypeEnName = this.expendEnName;
      this.expend.szType = 2;
      this.expend.orgIds = this.selectShops;
      this.expend.createName = this.userName;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/expend`,this.expend);
      if (res.code === 200){
        this.$message.success("添加成功");
      }
      await this.loadOrgExpends();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeExpendDialog();
    },
    async queryOrgExpendList(){
      this.baseRequest.startDate = '';
      this.baseRequest.endDate = '';
      if (this.baseRequest.selectDate !== null){
        this.baseRequest.startDate = this.baseRequest.selectDate[0];
        this.baseRequest.endDate = this.baseRequest.selectDate[1];
      }
      this.baseRequest.pageNum = this.currentPage;
      this.baseRequest.pageSize = this.pageSize;
      if (this.selectOrgId === ''){
        this.baseRequest.orgId = this.orgId;
      } else {
        this.baseRequest.orgId = this.selectOrgId;
      }
      await this.loadOrgExpends();
    },
    async loadExpendTypes(){
      const {data:res} = await this.$http.get(`/orgExpendType/orgId/${this.orgId}`)
      this.expendTypes = res.data;
    },
    async loadSelectExpendTypes(){
      const {data:res} = await this.$http.get(`/orgExpendType/orgId/${this.orgId}`)
      let expend = {
        expendCnName:'营业收入',
        expendEnName:'shouru'
      }
      this.selectExpendTypes = res.data;
      this.selectExpendTypes.push(expend)
    },
    getExpendType(data){
      this.expendEnName = data;
      if (data === ''){
        this.expend.expendTypeEnName = '';
      }
    },
    async loadOrgExpends(){
      const {data:res} = await this.$http.post(`/orgExpend/query`, this.baseRequest)
      this.orgExpendList = res.data.list;
      this.currentTotal = res.data.total;
    },
    //加载查询条件的机构
    async loadQueryOrg(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.orgList = res.data;
    },
    //加载全部的机构
    async loadAllOrg(){
      const {data:res} = await this.$http.get(`/load/all/shops`);
      this.orgList = res.data;
    },
    //加载当前登录用户所在的门店
    async loadCurrentUserOrg(){
      const {data:res} = await this.$http.get(`/load/all/shops`);
      this.orgList = res.data;
    },
    async deleteOrgExpend(data){
      const {data:res} = await this.$http.delete(`/expend/id/${data.id}`);
      if (res.code === 200){
        this.$message.success("操作成功");
      }
      await this.loadOrgExpends();
    },
    showSrDialog(){
      this.expend.expendDate = '';
      this.expend.money = '';
      this.expend.comment = '';
      this.selectShops = [];
      this.srDialogVisible = true;
    },
    closeSrDialog(){
      this.srDialogVisible = false;
    },
    async createSr(){
      if (this.expend.money === ''){
        return this.$message.warning("请填写金额！")
      }
      this.expend.creator = this.userId;
      this.expend.orgId  = this.orgId;
      this.expend.expendTypeEnName = 'shouru';
      this.expend.szType = 1;
      this.expend.orgIds = this.selectShops;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/sr`,this.expend);
      if (res.code === 200){
        this.$message.success("添加成功");
      }
      await this.loadOrgExpends();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeSrDialog();
    },
    nameFormatter(row){
      let value = '';
      if (row.expendTypeEnName === 'shouru'){
        value = '营业收入';
      } else {
        value = row.expendTypeCnName;
      }
      return value;
    },
    szFormatter(row){
      let value = '';
      if (row.szType === 1){
        value = '收';
      } else {
        value = '支';
      }
      return value;
    },
    orderStateColor({row,columnIndex}){
      if (row.szType === 1 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.szType === 2 && columnIndex ===2){
        return 'color:#ff0000';
      }
    },
    getSelectShop(data){
      this.costRequest.orgId = data;
    },
    showShopDialog(){
      this.shopDialogVisible = true;
      this.loadShop();
    },
    closeShopDialog(){
      this.shopDialogVisible = false;
    },
    async loadShop(){
      this.baseRequest.pageSize = this.pageSize1;
      this.baseRequest.pageNum = this.currentPage1;
      this.baseRequest.orgId = this.orgId;
      const {data:res} = await this.$http.post(`/orgs/shop`, this.baseRequest);
      this.shops = res.data.list;
      this.currentTotal1 = res.data.total;
    },
    selectShopMethod(val){
      this.selectShops = val;
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadShop();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadShop();
    },
    deleteShopShowList(index,rows){
      rows.splice(index, 1);
    },
    showUpdateExpendDialog(data){
      this.updateExpend = data;
      this.updateExpendDialogVisible = true;
    },
    closeUpdateExpendDialog(){
      this.updateExpendDialogVisible = false;
    },
    async updateShopExpend(){
      this.updateExpend.modifier = this.userId;
      this.updateExpend.modifyName = this.userName;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/update/expend`, this.updateExpend);
      if (res.code === 200){
        this.$message.success("修改成功！")
      }
      await this.queryOrgExpendList();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeUpdateExpendDialog();
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.userName = window.sessionStorage.getItem("userName");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadExpendTypes();
    this.loadSelectExpendTypes();
    this.queryOrgExpendList();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopExpend.vue